import { Children, FC } from 'react';
import { useLocation } from 'react-router-dom';

import { Box } from '@mui/material';
import { SUBSCRIPTION_PLAN_2 } from 'constants/paths';
import { ISubscriptionPlanLayoutProps } from 'layouts/SubscriptionPlansLayout/types';
import { useUserSubscriptionStore } from 'store/useUserSubscriptionStore';
import { getUserSubscription } from 'store/useUserSubscriptionStore/selectors';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import './SubscriptionPlansMobileView.scss';

import { SUBSCRIPTION_PLAN } from 'interfaces/subscriptions';

export const SubscriptionPlansMobileView: FC<ISubscriptionPlanLayoutProps> = ({ children }) => {
  const userSubscription = useUserSubscriptionStore(getUserSubscription);

  const location = useLocation();
  const isOnlyPayedSubscriptionPage = location.pathname === SUBSCRIPTION_PLAN_2;
  const isCurrentSubscriptionFree = userSubscription?.currentSubscription.subscriptionPlan === SUBSCRIPTION_PLAN.FREE;
  const initialSlideNumber = isOnlyPayedSubscriptionPage
    ? 0
    : isCurrentSubscriptionFree && isCurrentSubscriptionFree
      ? 1
      : 0;
  return (
    <>
      <Swiper
        loop
        slidesPerView={1}
        initialSlide={initialSlideNumber}
        speed={300}
        className="subscriptionPlanSwiperContainer"
        modules={[Pagination]}
        height={400}
        pagination={{
          el: '.subscriptionPlanSwiperPagination',
          renderBullet: (index: number, className: string) =>
            `<span key="${index}" class="${className} subscriptionPlansMobileViewDot" ></span>`,
        }}
      >
        {Children.map(children, (child, index) => (
          <SwiperSlide key={index} className="subscriptionPlanSwiperSlider">
            {child}
          </SwiperSlide>
        ))}
      </Swiper>
      <Box className="subscriptionPlanSwiperPagination" />
    </>
  );
};
